import { render } from "./AddTraineeModal.vue?vue&type=template&id=e5243cba&scoped=true"
import script from "./AddTraineeModal.vue?vue&type=script&lang=js"
export * from "./AddTraineeModal.vue?vue&type=script&lang=js"

import "./AddTraineeModal.vue?vue&type=style&index=0&id=e5243cba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5243cba"]])

export default __exports__